import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import AboutSection from "./components/AboutSection";
import ArticlesGrid from "./components/ArticlesGrid";
import Testimonial from "./components/Testimonial";
import Footer from "./components/Footer";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuy.courses";

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Kakobuy Courses",
    "url": siteUrl,
    "description": "Kakobuy Spreadsheet – najlepszy arkusz zakupowy dla Polski. Sprawdzone linki do produktów, szybka dostawa i bezpieczne zakupy online.",
    "inLanguage": "pl-PL",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Kakobuy Courses",
    "url": siteUrl,
    "description": "Kakobuy Spreadsheet – sprawdzone linki do produktów, szybka dostawa i bezpieczne zakupy online w Polsce.",
    "foundingDate": "2025",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["Polish", "English"],
    },
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <CTASection />
        <AboutSection />
        <ArticlesGrid />
        <Testimonial />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
    </>
  );
}